import { getTranslationQuota } from '../api';

import { useDispatch, useSelector } from '../../../react-redux';
import { setTranslateQuota } from '../../../reducers/translate';

const useTranslateQuota = () => {
  const dispatch = useDispatch();
  const translateQuota = useSelector(state => state.getIn(['translate', 'translateQuota']));

  const getTranslationQuotaInfo = () => {
    // return new Promise((resolve, reject) => {
    //   getTranslationQuota()
    //     .then(resp => {
    //       // const {ext_num, total_num, used_num} = resp.data
    //       if (resp.data) {
    //         dispatch(setTranslateQuota(resp.data));
    //         resolve(resp.data);
    //       } else {
    //         reject();
    //       }
    //     })
    //     .catch(() => {
    //       reject();
    //     });
    // });
  };

  return {
    translateQuota,
    getTranslationQuotaInfo
  };
};

export default useTranslateQuota;
